module.exports = new Promise((resolve) => {
    const baseUrl = (window.RUNTIME && window.RUNTIME['ASSOCIATE_REMOTE_URL']) || '';

    if (!baseUrl) {
      console.error('Missing associate remote URL');
      return resolve({
        get: () => Promise.reject(new Error('Missing associate remote URL')),
        init: () => {}
      });
    }

    const remoteUrl = (() => {
      const separator = baseUrl.includes('?') ? '&' : '?';
      return `${baseUrl}${separator}t=${Date.now()}`;
    })();

    if (window['associateApp']) {
      const existingContainer = window['associateApp'];
      return resolve({
        get: (request) => existingContainer.get(request),
        init: (arg) => {
          try {
            return existingContainer.init(arg);
          } catch (_) {}
        }
      });
    }

    const existingScript = document.querySelector('script[data-mf-remote="associateApp"]');
    if (existingScript) {
      existingScript.addEventListener('load', () => {
        const container = window['associateApp'];
        if (!container) {
          return resolve({
            get: () => Promise.reject(new Error('associateApp not found')),
            init: () => {}
          });
        }

        resolve({
          get: (request) => container.get(request),
          init: (arg) => {
            try {
              return container.init(arg);
            } catch (_) {}
          }
        });
      });

      existingScript.addEventListener('error', () => {
        resolve({
          get: () => Promise.reject(new Error('Failed loading associate remote')),
          init: () => {}
        });
      });

      return;
    }

    const el = document.createElement('script');
    el.src = remoteUrl;
    el.type = 'text/javascript';
    el.async = true;
    el.crossOrigin = 'anonymous';
    el.dataset.mfRemote = 'associateApp';

    el.onload = () => {
      const container = window['associateApp'];
      if (!container) {
        console.error('Remote container "associateApp" not found on window');
        return resolve({
          get: () => Promise.reject(new Error('associateApp not found')),
          init: () => {}
        });
      }

      resolve({
        get: (request) => container.get(request),
        init: (arg) => {
          try {
            return container.init(arg);
          } catch (_) {}
        }
      });
    };

    el.onerror = () => {
      console.error('Failed to load remoteEntry:', remoteUrl);
      el.remove();
      resolve({
        get: () => Promise.reject(new Error('Failed loading associate remote')),
        init: () => {}
      });
    };

    document.head.appendChild(el);
  })
;